import { render, staticRenderFns } from "./CourseEventFormSessionList.vue?vue&type=template&id=0147d0b6&scoped=true"
import script from "./CourseEventFormSessionList.vue?vue&type=script&lang=js"
export * from "./CourseEventFormSessionList.vue?vue&type=script&lang=js"
import style0 from "./CourseEventFormSessionList.vue?vue&type=style&index=0&id=0147d0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0147d0b6",
  null
  
)

export default component.exports